(() => {
  function buildAjaxUrl(baseUrl, view) {
    view = view || 'ajax-card';
    try {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('view', view);
      return url.toString();
    } catch (e) {
      if (baseUrl.indexOf('?') === -1) {
        return baseUrl + '?view=' + view;
      }
      return baseUrl + '&view=' + view;
    }
  }

  async function handleSiblingSwatchClick(event, link) {
    event.preventDefault();

    const siblingUrl = link.dataset.siblingUrl || link.getAttribute('href');
    if (!siblingUrl) return;

    const card = link.closest('.card');
    const modal = link.closest('.product-modal, .modal[data-quick-buy-modal]');

    if (modal) {
      try {
        const ajaxUrl = buildAjaxUrl(siblingUrl, 'ajax-modal');
        const res = await fetch(ajaxUrl, { credentials: 'same-origin' });
        if (!res.ok) return;

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newModal = doc.querySelector('.modal.product-modal, [data-quick-buy-modal]');
        if (!newModal) return;

        modal.id = newModal.id;
        modal.innerHTML = newModal.innerHTML;
        modal.dispatchEvent(new CustomEvent('quick-buy-modal-content-replaced', { bubbles: true }));
      } catch (err) {
        console.error('Failed to load sibling product modal', err);
      }
      return;
    }

    if (!card) return;

    const ajaxUrl = buildAjaxUrl(siblingUrl);

    try {
      const res = await fetch(ajaxUrl, { credentials: 'same-origin' });
      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newCard = doc.querySelector('.card');
      if (!newCard) return;

      card.replaceWith(newCard);
    } catch (err) {
      console.error('Failed to load sibling product card', err);
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-sibling-url]');
    if (!link) return;
    handleSiblingSwatchClick(event, link);
  });
})();

